import { render, staticRenderFns } from "./RazPlus.vue?vue&type=template&id=3d39ff86&scoped=true"
import script from "./RazPlus.vue?vue&type=script&lang=js"
export * from "./RazPlus.vue?vue&type=script&lang=js"
import style0 from "./RazPlus.vue?vue&type=style&index=0&id=3d39ff86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d39ff86",
  null
  
)

export default component.exports